export const Enter = {
  key: 'Enter',
  which: 13,
  keyCode: 13,
};

export const Escape = {
  key: [
    'Escape',
    // IE11 Escape
    'Esc',
  ],
  which: 27,
  keyCode: 27,
};

export const Space = {
  key: ' ',
  which: 32,
  keyCode: 32,
};
